$(document).ready(function(){
    $('.u_var_desp').each(function(){
      $('.u_desp_part').append('<a href="javascript:void(0);" class="read_more">Read More</a>');
    })
    $('.read_more').click(function(){
      $(this).parent().find('.u_long_desp').toggleClass('u_hide u_inline');   
          $('.u_var_desp').toggleClass('active_desp');
      var text = $(this).parent().find('.read_more').text();
      console.log(text);
      $(this).text(text == "read less" ? "read more" : "read less");
    })
   $('.u_accordian_head').click(function(){
                // self clicking
                // animation
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
                    $(this).find('.u_icon').addClass('plus').removeClass('minus');
                 }
                else{
                    $('.u_accordian_body').removeClass('active').slideUp();
                $('.u_icon').addClass('plus').removeClass('minus');
            $(this).next('.u_accordian_body').addClass('active').slideDown();
            $(this).find('.u_icon').addClass('minus').removeClass('plus');
                }
            })
  })